import { routes as academico } from './academico';
import { routes as biblioteca } from './biblioteca';
import { routes as gestao } from './gestao';
import { routes as patrimonio } from './patrimonio';
import { routes as pessoal } from './pessoal';
import { routes as ferramentas } from './ferramentas';
import { routes as administracao } from './administracao';
import { routes as centralvagas } from './centralvagas';
import { routes as censoescolar } from './censoescolar';
import { routes as publicas } from './publicas';
import { routes as global } from './global';
import { routes as calendario } from './calendario';
import { routes as gesparametros } from './gesparametros';
import { routes as distribuicoes } from './academico/distribuicao';
import { routes as merenda } from './merenda';
import { routes as dashboard } from './dashboard';
import { routes as ged } from './ged';
import { routes as prestacaoContas } from './prestacaocontas';
import { routes as transporte } from './transporte';
import { routes as gestaousuarios } from './gestaousuarios';
import { routes as educacaoinclusiva } from './educacaoinclusiva';
import { routes as atendimentoestudante } from './atendimentoestudante';
export default [
  {
    path: '/',
    name: 'Landing Page',
    goesToMenu: false,
    description: 'Landing Page',
    meta: {
      requiresAuth: false,
    },
    component: () => import('@/views/landing-page/Index.vue'),
    children: [],
  },
  {
    path: '/ferramentas/reports/report-view/:id?',
    name: 'report-view',
    description: 'Visualizador de Relatório',
    goesToMenu: false,
    meta: {
      requiresAuth: true,
    },
    component: () => import('@/views/ferramentas/reports/ReportView.vue'),
  },
  {
    path: '/privacy-policy',
    name: 'Privacy Policy',
    description: 'Política de Privacidade',
    goesToMenu: false,
    meta: {
      requiresAuth: false,
    },
    component: () => import('@/views/privacy-policy/Index.vue'),
  },
  {
    path: '/login/:id?',
    name: 'login',
    description: 'login',
    meta: {
      requiresAuth: false,
    },
    component: () => import('@/views/login/Login.vue'),
  },
  {
    path: '/login', //Temporário para MOC. Depois jogar essa rota fora
    name: 'login.aspx',
    description: 'login',
    meta: {
      requiresAuth: false,
    },
    component: () => import('@/views/login/Login.vue'),
  },
  {
    path: '/recuperar-senha',
    name: 'Recuperar Senha',
    description: 'Recuperar Senha',
    meta: {
      requiresAuth: false,
    },
    component: () => import('@/views/login/RecuperarSenha.vue'),
  },
  {
    path: '/alterar-senha',
    name: 'Alterar Senha',
    description: 'Alterar Senha',
    meta: {
      requiresAuth: false,
    },
    component: () => import('@/views/login/AlterarSenha.vue'),
  },
  {
    path: '/proxylegado/:tela',
    name: 'proxyLegado',
    description: 'legado',
    component: () => import('@/views/legado/Proxy.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    name: '404',
    /* WCAG 2.4.2 — o título tem de descrever o tópico ou a finalidade da página. "404"
        é o código de status, não o assunto: numa aba entre várias, não diz nada. */
    description: 'Página não encontrada',
    meta: {
      requiresAuth: false,
    },
    component: () => import('@/layout/maintemplate/MainTemplate.vue'),
    children: [
      {
        path: '',
        name: 'notfound',
        /* A rota ATIVA é a filha, e é o `description` dela que o
           `anuncio-navegacao.service.ts` usa para montar o `document.title`. Sem este
           campo o título saía vazio e a aba ficava sem nome (WCAG 2.4.2). */
        description: 'Página não encontrada',
        component: () => import('@/views/notfound/NotFound.vue'),
      },
    ],
  },
  {
    path: '/error',
    name: 'error',
    /* Ver o comentário do 404 acima: código de status não é título de página. */
    description: 'Acesso negado',
    meta: {
      requiresAuth: false,
    },
    component: () => import('@/layout/maintemplate/MainTemplate.vue'),
    children: [
      {
        path: '',
        name: 'accessdenied',
        /* Ver o comentário em `notfound`: é o `description` da rota FILHA que vira título. */
        description: 'Acesso negado',
        component: () => import('@/views/auth/AccessDenied.vue'),
      },
    ],
  },
  {
    path: '/home',
    name: 'home',
    description: 'home',
    meta: {
      requiresAuth: true,
    },
    component: () => import('@/layout/maintemplate/MainTemplate.vue'),
    children: [
      {
        path: '',
        name: 'home2',
        description: 'Home',
        component: () => import('@/views/home/Index.vue'),
      },
      ...academico, //Incluindo aqui eu aplico o template e também ativa a rota (ou seja, lê a rota separada por módulos)
      ...biblioteca,
      ...gestao,
      ...patrimonio,
      ...pessoal,
      ...ferramentas,
      ...administracao,
      ...centralvagas,
      ...censoescolar,
      ...publicas,
      ...global,
      ...calendario,
      ...gesparametros,
      ...distribuicoes,
      ...merenda,
      ...prestacaoContas,
      ...transporte,
      ...dashboard,
      ...ged,
      ...gestaousuarios,
      ...educacaoinclusiva,
      ...atendimentoestudante,
    ],
  },
  {
    path: '/homeprofessor',
    name: 'homeprofessor',
    description: 'Painel do Professor',
    meta: {
      requiresAuth: true,
    },
    component: () => import('@/layout/maintemplate/MainTemplate.vue'),
    children: [
      {
        path: '',
        name: 'homep',
        description: 'Painel do Professor',
        component: () => import('@/views/homeprofessor/Index.vue'),
      },
    ],
  },
  {
    path: '/homealuno',
    name: 'homealuno',
    description: 'Painel do Aluno',
    meta: {
      requiresAuth: true,
    },
    component: () => import('@/layout/maintemplate/MainTemplate.vue'),
    children: [
      {
        path: '',
        name: 'homea',
        description: 'Painel do Aluno',
        component: () => import('@/views/homealuno/Index.vue'),
      },
    ],
  },
  {
    path: '/homeresponsavel',
    name: 'homeresponsavel',
    description: 'Painel do Responsável',
    meta: {
      requiresAuth: true,
    },
    component: () => import('@/layout/maintemplate/MainTemplate.vue'),
    children: [
      {
        path: '',
        name: 'homer',
        description: 'Painel do Responsável',
        component: () => import('@/views/homeresponsavel/Index.vue'),
      },
    ],
  },
];
